export const labels = {
    OUT_OF_FRANCHISE_TITLE: "Verizon Fios isn’t available",
    OUT_OF_FRANCHISE_TITLE1: "for your location, yet.",
    ADDRESS_CHANGE_BTN: "Change Addres",
    SMALL_BUSINESS_CONTENT: "Know when Fios is available",
    SMALL_BUSINESS_CONTENT1: "Register and get notified when Fios is available in your area.",
    SMALL_BUSINESS_CONTENT2: "Choose the wireless plan to keep your business ready for anything.",
    SMALL_BUSINESS_CONTENT3: "Get the right business wireless plan.",
    SMALL_BUSINESS_CONTACT: "Call us to order :",
    SMALL_BUSINESS_CONTACT_NO: "1-800-274-8002",
    REGISTER_BTN: "Register",
    REGISTER_LINK: "/foryoursmallbiz/gborder/fios-registration",
    SMALL_BUSINESS_CONTENT4: "To be notified when Fios is Available."

}
